import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnarchiveFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21 5.5H3C2.448 5.5 2 5.22 2 4.875V3.625C2 3.28 2.448 3 3 3H21C21.552 3 22 3.28 22 3.625V4.875C22 5.22 21.552 5.5 21 5.5Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.667 7V19C20.667 20.105 19.772 21 18.667 21H5.33301C4.22801 21 3.33301 20.105 3.33301 19V7H20.667ZM12.5303 11.4697C12.2374 11.1768 11.7626 11.1768 11.4697 11.4697L9.46967 13.4697C9.17678 13.7626 9.17678 14.2374 9.46967 14.5303C9.76256 14.8232 10.2374 14.8232 10.5303 14.5303L11.25 13.8107V16.3491C11.25 16.7633 11.5858 17.0991 12 17.0991C12.4142 17.0991 12.75 16.7633 12.75 16.3491V13.8107L13.4697 14.5303C13.7626 14.8232 14.2374 14.8232 14.5303 14.5303C14.8232 14.2374 14.8232 13.7626 14.5303 13.4697L12.5303 11.4697Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgUnarchiveFilled);
export default ForwardRef;
